{
  "actionbar.actions": "Działania",
  "actionbar.actionsAvailable": "Dostępne działania.",
  "actionbar.clearSelection": "Wyczyść zaznaczenie",
  "actionbar.selected": "Zaznaczono: {count}",
  "actionbar.selectedAll": "Wszystkie zaznaczone",
  "button.pending": "oczekujące",
  "contextualhelp.help": "Pomoc",
  "contextualhelp.info": "Informacja",
  "dialog.alert": "Ostrzeżenie",
  "dialog.dismiss": "Zignoruj",
  "dropzone.replaceMessage": "Upuść plik, aby zastąpić",
  "inlinealert.informative": "Informacja",
  "inlinealert.negative": "Błąd",
  "inlinealert.notice": "Ostrzeżenie",
  "inlinealert.positive": "Powodzenie",
  "label.(optional)": "(opcjonalne)",
  "label.(required)": "(wymagane)",
  "menu.moreActions": "Więcej akcji",
  "picker.placeholder": "Zaznacz…",
  "slider.maximum": "Maksimum",
  "slider.minimum": "Minimum",
  "table.loading": "Ładowanie...",
  "table.loadingMore": "Wczytywanie większej liczby...",
  "table.resizeColumn": "Zmień rozmiar kolumny",
  "table.sortAscending": "Sortuj rosnąco",
  "table.sortDescending": "Sortuj malejąco",
  "tag.actions": "Działania",
  "tag.hideButtonLabel": "Wyświetl mniej",
  "tag.noTags": "Brak",
  "tag.showAllButtonLabel": "Pokaż wszystko ({tagCount, number})",
  "breadcrumbs.more": "Więcej elementów"
}